var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.33339V28.0001M16 9.33339C15.5177 7.34593 14.6873 5.6468 13.617 4.4576C12.5467 3.2684 11.2862 2.64431 10 2.66672C9.11595 2.66672 8.2681 3.01791 7.64298 3.64303C7.01786 4.26815 6.66667 5.116 6.66667 6.00005C6.66667 6.88411 7.01786 7.73196 7.64298 8.35708C8.2681 8.9822 9.11595 9.33339 10 9.33339M16 9.33339C16.4823 7.34593 17.3127 5.6468 18.383 4.4576C19.4533 3.2684 20.7138 2.64431 22 2.66672C22.8841 2.66672 23.7319 3.01791 24.357 3.64303C24.9821 4.26815 25.3333 5.116 25.3333 6.00005C25.3333 6.88411 24.9821 7.73196 24.357 8.35708C23.7319 8.9822 22.8841 9.33339 22 9.33339M26.6667 14.6667V25.3334C26.6667 26.0406 26.3857 26.7189 25.8856 27.219C25.3855 27.7191 24.7072 28.0001 24 28.0001H8C7.29276 28.0001 6.61448 27.7191 6.11438 27.219C5.61428 26.7189 5.33333 26.0406 5.33333 25.3334V14.6667M26.6667 14.6667C27.403 14.6667 28 14.0698 28 13.3334V10.6667C28 9.93034 27.403 9.33339 26.6667 9.33339H5.33333C4.59695 9.33339 4 9.93034 4 10.6667V13.3334C4 14.0698 4.59695 14.6667 5.33333 14.6667M26.6667 14.6667H5.33333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.91914459137d1f788621b82592ba591f.svg";
export { ForwardRef as ReactComponent };